import React, { useEffect, useState } from 'react'

export default function Anbefalinger() {
  useEffect(() => {
    document.title = 'Anbefalinger | Køreskole i Kalundborg | Tilmeld dig i dag'
    const metaDesc = document.querySelector('meta[name="description"]')
    if (metaDesc) {
      metaDesc.setAttribute(
        'content',
        'Læs anbefalinger fra tidligere elever hos Borgs Køreskole I/S i Kalundborg. Se hvad eleverne siger om køreundervisningen.'
      )
    }
  }, [])

  const [formState, setFormState] = useState({
    name: '',
    email: '',
    message: '',
    website_url: '' // honeypot
  })
  const [submitted, setFormSubmitted] = useState(false)
  const [submitting, setFormSubmitting] = useState(false)
  const [error, setFormError] = useState('')

  const handleSubmit = async (e) => {
    e.preventDefault()
    setFormSubmitting(true)
    setFormError('')

    try {
      const response = await fetch('https://api.dev.auxo.dk/webform/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formState)
      })

      if (response.ok) {
        setFormSubmitted(true)
      } else {
        setFormError('Nogle felter er ikke udfyldt korrekt')
      }
    } catch (err) {
      setFormError('Der opstod en fejl. Prøv venligst igen.')
    } finally {
      setFormSubmitting(false)
    }
  }

  const reviews = [
    {
      author: 'Corné Engsvang',
      text: 'Har haft en rigtig god oplevelse af denne forløb. Bedste køreskole i kalundborg! Rigtig gode teori timer hos Mette og en rigtig god forløb med at køre med Kim'
    },
    {
      author: 'Matilde Larsen',
      text: 'Verdens bedste køreskole! Jeg vil uden tvivl anbefale Borgs køreskole til enhver person som kommer og spørger! Mette og Kim er de mest fantastiske mennesker'
    },
    {
      author: 'Mohamed Gamal',
      text: 'Fantastisk køreskole. Hyggelige kørelærere der endda sætter mere tid af til undervisningen end hvad der er lovkrav. Teori er også nemmere at forstå, da der bliver brugt minibil-magneter, og generelt en meget god stemning 10/10.'
    },
    {
      author: 'Barbara Sabljak',
      text: 'Jeg giver min varmeste anbefaling til Mette og Kim, jeg er 52 år, og skulle tage mit første kørekort, det har været en tryg oplevelse, Mette er eminent til at undervise.'
    },
    {
      author: 'Lene Johansen',
      text: 'Super fantastiske kørelære og teorilære. Jeg er super glad for i kunne hjælpe mig så jeg kunne få det kørekort.'
    },
    {
      author: 'Mathilde Knudsen',
      text: 'Fantastisk kørelærer! Jeg kom fra en anden køreskole, men fik hurtigt den støtte og læring, jeg manglede. Kan stærkt anbefales.'
    }
  ]

  return (
    <div className="bg-slate-50 min-h-screen py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
        {/* Reviews List */}
        <div className="bg-white p-8 sm:p-12 border border-slate-200 shadow-sm space-y-8">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-b border-slate-200 pb-4">
            <h1 className="font-header text-3xl sm:text-4xl font-extrabold text-slate-900">
              Hvad siger eleverne hos Borgs Køreskole
            </h1>
            <a
              href="https://www.google.com/search?q=Borgs+K%C3%B8reskole+Anmeldelser"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-sm font-bold text-emerald-700 hover:text-emerald-800"
            >
              <span>Se flere anmeldelser</span>
              <i className="fa-solid fa-arrow-up-right-from-square text-xs" aria-hidden="true"></i>
            </a>
          </div>

          <div className="space-y-6">
            {reviews.map((rev, idx) => (
              <div key={idx} className="p-6 bg-slate-50 border border-slate-200 rounded-lg space-y-3">
                <p className="text-slate-700 whitespace-pre-line leading-relaxed">
                  {rev.text}
                </p>
                <p className="font-bold text-slate-900 pt-2 border-t border-slate-200/80">
                  {rev.author}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Main Content Box */}
        <div className="bg-white p-8 sm:p-12 border border-slate-200 shadow-sm space-y-6">
          <h2 className="font-header text-3xl sm:text-4xl font-extrabold text-slate-900">
            Anbefalinger
          </h2>
          <p className="text-slate-700 text-base leading-relaxed">
            På denne side, kan du læse hvordan oplevelsen hos Borgs Køreskole, har været hos de forskellige elever gennem tiden.
          </p>

          <section className="pt-6 border-t border-slate-200 space-y-4">
            <h3 className="font-header text-2xl font-bold text-slate-900">
              Har du haft en god oplevelse?
            </h3>
            <p className="text-slate-700">
              Hvis du har været elev hos Borgs Køreskole, og godt kunne tænke dig at fortælle om din oplevelse hos os, skal du være mere end velkommen til at benytte vores formular, og fortælle om din tid hos os.
            </p>

            {submitted ? (
              <div className="p-4 bg-emerald-50 border border-emerald-200 text-emerald-800 font-bold rounded-lg">
                Tak for din anbefaling! Vi sætter stor pris på din feedback.
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-4 max-w-xl bg-slate-50 p-6 border border-slate-200 rounded-lg">
                {/* Honeypot */}
                <div className="sr-only absolute -left-[9999px]" aria-hidden="true">
                  <input
                    type="text"
                    name="website_url"
                    tabIndex="-1"
                    value={formState.website_url}
                    onChange={(e) => setFormState({ ...formState, website_url: e.target.value })}
                    autoComplete="off"
                  />
                </div>

                {error && (
                  <div className="p-3 bg-red-50 border border-red-200 text-red-700 text-sm font-semibold rounded">
                    {error}
                  </div>
                )}

                <div>
                  <label className="block text-sm font-bold text-slate-900 mb-1">
                    Navn <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    required
                    value={formState.name}
                    onChange={(e) => setFormState({ ...formState, name: e.target.value })}
                    className="w-full px-4 py-2 border border-slate-300 rounded-md focus:ring-2 focus:ring-emerald-500 focus:outline-none"
                  />
                </div>

                <div>
                  <label className="block text-sm font-bold text-slate-900 mb-1">
                    E-mail <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="email"
                    required
                    value={formState.email}
                    onChange={(e) => setFormState({ ...formState, email: e.target.value })}
                    className="w-full px-4 py-2 border border-slate-300 rounded-md focus:ring-2 focus:ring-emerald-500 focus:outline-none"
                  />
                </div>

                <div>
                  <label className="block text-sm font-bold text-slate-900 mb-1">
                    Din anbefaling / Besked
                  </label>
                  <textarea
                    rows="4"
                    value={formState.message}
                    onChange={(e) => setFormState({ ...formState, message: e.target.value })}
                    className="w-full px-4 py-2 border border-slate-300 rounded-md focus:ring-2 focus:ring-emerald-500 focus:outline-none"
                  ></textarea>
                </div>

                <button
                  type="submit"
                  disabled={submitting}
                  className="px-6 py-2.5 bg-[#8cc73d] hover:bg-[#7eb832] text-slate-950 font-bold rounded-full transition-colors disabled:opacity-50"
                >
                  {submitting ? 'Sender...' : 'Send anbefaling'}
                </button>
              </form>
            )}
          </section>
        </div>
      </div>
    </div>
  )
}
